var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    'radio',
    _vm.border && 'radio--bordered',
    _vm.value === _vm.option && 'radio--active',
  ],on:{"click":_vm.switchValue}},[_c('div',{class:['radio__radio', _vm.value === _vm.option && 'radio__radio--active']}),(_vm.label)?_c('div',{staticClass:"radio__label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }